import { createContext, useReducer } from "react"
import AuthReducer from "./authReducer"

const INITIAL_STATE = {
    user: null,
    isFetching: false,
    isError: false
}

export const AuthContext = createContext(INITIAL_STATE)

export const AuthContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE)

    return (
        <AuthContext.Provider 
            value={{ 
                user: state.user,
                isFetching: state.isFetching,
                isError: state.isError,
                dispatch
            }}
        >
            { children }
        </AuthContext.Provider>
    )
}